<template>
    <div>
        <breadcrumb :routerList="[{to:'/',title:'首页'},{title:'内销财务改数版公式维护'}]"/>
        <div class="h-content">
            <!--表单-->
            <!--            <div class="h-formLine">-->
            <!--                <el-form ref="form" :model="f"-->
            <!--                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">-->

            <!--                    <el-form-item label="主键id" prop="id" :rules="[-->
            <!--								  { required: true, message: '请输入主键id名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.id"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="元素类型   f 从其他取数   g 计算公式   s 输入   t 特殊判断" prop="type" :rules="[-->
            <!--								  { required: true, message: '请输入元素类型   f 从其他取数   g 计算公式   s 输入   t 特殊判断名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.type"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="公式编号" prop="formulanum" :rules="[-->
            <!--								  { required: true, message: '请输入公式编号名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.formulanum"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="公式名" prop="name" :rules="[-->
            <!--								  { required: true, message: '请输入公式名名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.name"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="公式" prop="formula" :rules="[-->
            <!--								  { required: true, message: '请输入公式名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.formula"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="大项名" prop="proName" :rules="[-->
            <!--								  { required: true, message: '请输入大项名名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.proName"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="模块名" prop="modelName" :rules="[-->
            <!--								  { required: true, message: '请输入模块名名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.modelName"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="说明" prop="oper" :rules="[-->
            <!--								  { required: true, message: '请输入说明名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.oper"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="计算备注" prop="ratetext" :rules="[-->
            <!--								  { required: true, message: '请输入计算备注名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.ratetext"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="创建人编码" prop="cucode" :rules="[-->
            <!--								  { required: true, message: '请输入创建人编码名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.cucode"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="创建人名称" prop="cuname" :rules="[-->
            <!--								  { required: true, message: '请输入创建人名称名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.cuname"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="创建时间" prop="cdate" :rules="[-->
            <!--								  { required: true, message: '请输入创建时间名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.cdate"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="修改人编码" prop="lucode" :rules="[-->
            <!--								  { required: true, message: '请输入修改人编码名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.lucode"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="最后更新时间" prop="ldate" :rules="[-->
            <!--								  { required: true, message: '请输入最后更新时间名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.ldate"></el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="可用标志。1：可用,0：删除标志" prop="delflag" :rules="[-->
            <!--								  { required: true, message: '请输入可用标志。1：可用,0：删除标志名称', trigger: 'blur'},-->
            <!--								]" class="h-elformWrap-1">-->
            <!--                        <el-input v-model="f.delflag"></el-input>-->
            <!--                    </el-form-item>-->

            <!--                </el-form>-->
            <!--            </div>-->

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">

                        <el-form-item label="主键id">
                            <el-input v-model="q.id"></el-input>
                        </el-form-item>
                        <el-form-item label="元素类型" style="margin-left: 0.3rem;">
                            <el-input v-model="q.type"></el-input>
                        </el-form-item>
                        <el-form-item label="公式编号" style="margin-left: 0.3rem;">
                            <el-input v-model="q.formulanum"></el-input>
                        </el-form-item>
                        <el-form-item label="公式名" style="margin-left: 0.3rem;">
                            <el-input v-model="q.name"></el-input>
                        </el-form-item>
                        <el-form-item label="公式" style="margin-left: 0.2rem;">
                            <el-input v-model="q.formula"></el-input>
                        </el-form-item>

                        <el-form-item class="h-formBtnOut" style="margin-left: 0.3rem;">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        </el-form-item>

                        <el-form-item label="" class="h-elformWrap-2">
                            <el-switch
                                    @click="chooseModify"
                                    v-model="moreCondition"
                                    active-text="更多条件"
                                    inactive-text="">
                            </el-switch>
                        </el-form-item>

                        <div class="h-pieceCon2" v-if="this.moreCondition">
                        <el-form-item label="大项名" style="margin-left: 0.6rem;">
                            <el-input v-model="q.proName"></el-input>
                        </el-form-item>
                        <el-form-item label="模块名" style="margin-left: 1rem;">
                            <el-input v-model="q.modelName"></el-input>
                        </el-form-item>
                        <el-form-item label="说明" style="margin-left: 1.6rem;">
                            <el-input v-model="q.oper"></el-input>
                        </el-form-item>
                        <el-form-item label="计算备注" style="margin-left: 0.4rem;">
                            <el-input v-model="q.ratetext"></el-input>
                        </el-form-item>
                        <el-form-item label="创建人编码" style="margin-left: 0.6rem;">
                            <el-input v-model="q.cucode"></el-input>
                        </el-form-item>
                        <el-form-item label="创建人名称" style="margin-left: 1rem;">
                            <el-input v-model="q.cuname"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间" style="margin-left: 0.4rem;">
                            <el-input v-model="q.cdate"></el-input>
                        </el-form-item>
                        <el-form-item label="修改人编码" style="margin-left: 0.6rem;">
                            <el-input v-model="q.lucode"></el-input>
                        </el-form-item>
                        <el-form-item label="最后更新时间" style="margin-left: 0.8rem;">
                            <el-input v-model="q.ldate"></el-input>
                        </el-form-item>


                        </div>

                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
<!--                    <el-table-column-->
<!--                            type="index"-->
<!--                            label="#"-->
<!--                            width="40">-->
<!--                    </el-table-column>-->


                    <el-table-column
                            prop="id"
                            label="主键id"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="元素类型"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="formulanum"
                            label="公式编号"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="公式名"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="formula"
                            label="公式"
							:show-overflow-tooltip="true"
                            min-width="110">
                    </el-table-column>
                    <el-table-column
                            prop="proName"
                            label="大项名"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="modelName"
                            label="模块名"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="oper"
                            label="说明"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="ratetext"
                            label="计算备注"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                            prop="cucode"-->
<!--                            label="创建人编码"-->
<!--                            width="110">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="cuname"-->
<!--                            label="创建人名称"-->
<!--                            width="110">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            prop="cdate"-->
<!--                            label="创建时间"-->
<!--                            width="110">-->
<!--                    </el-table-column>-->
                    <el-table-column
                            prop="lucode"
                            label="修改人编码"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
                            width="130">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                            prop="delflag"-->
<!--                            label="可用标志。1：可用,0：删除标志"-->
<!--                            width="110">-->
<!--                    </el-table-column>-->


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="120"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    @click="xiigaishuzhi(scope.row)">编辑公式
                            </el-button>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-xg" title="编辑公式" @click="xiigaishuzhi(scope.row)"></span>
							</div> -->
                            <!--                            <el-button-->
                            <!--                                    size="mini"-->
                            <!--                                    type="danger"-->
                            <!--                                    @click="handleDelete(scope.row)">删除-->
                            <!--                            </el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query"/>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:0;" @click="outexcel">批量导出
                    </el-button>
                </div>
            </div>
        </div>


        <!-- 修改数值 -->
        <el-dialog :visible.sync="kaishixiugai" class="h-dialog2" :show-close="true" :close-on-click-modal="false">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>修改公式</h1>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-form :inline="false" :model="xiugaifrom" class="demo-form-inline h-formBorder">

                        <el-form-item label="公式id">
                            <el-input v-model="xiugaifrom.id" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="公式名">
                            <el-input v-model="xiugaifrom.name" ></el-input>
                        </el-form-item>

                        <el-form-item label="大项名">
                            <el-input v-model="xiugaifrom.proName" ></el-input>
                        </el-form-item>

                        <el-form-item label="公式">
                            <el-input type="textarea" v-model="xiugaifrom.formula" rows="10" :disabled="(xiugaifrom.type!='u'&&xiugaifrom.type!='w')"></el-input>
                        </el-form-item>

                        <el-form-item label="公式说明">
                            <el-input type="textarea" v-model="xiugaifrom.oper" rows="5"></el-input>
                        </el-form-item>

                        <el-form-item label="公式备注">
                            <el-input type="textarea" v-model="xiugaifrom.ratetext" rows="5"></el-input>
                        </el-form-item>

                        <el-form-item label="参数对照表">
                            <el-input type="textarea" v-model="xiugaifrom.duizhaobiao" rows="20" disabled="disabled"></el-input>
                        </el-form-item>

                    </el-form>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="quedingxiugai">确定</el-button>
                    </div>

                </div>

            </div>

        </el-dialog>


    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        components: {},
        data() {
            return {

                xiugaifrom:{

                    type:'',

                    duizhaobiao:'',

                    canshushuzu:[],

                    name:'',

                    proName:'',

                    modelName:'',

                    formula:'',

                    oper:'',

                    ratetext:'',

                    //被修改的id
                    id: '',


                },


                moreCondition: false,



                kaishixiugai: false,


                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },


                //表单
                f: {
                    id: null, // 主键id
                    type: null, // 元素类型   f 从其他取数   g 计算公式   s 输入   t 特殊判断
                    formulanum: null, // 公式编号
                    name: null, // 公式名
                    formula: null, // 公式
                    proName: null, // 大项名
                    modelName: null, // 模块名
                    oper: null, // 说明
                    ratetext: null, // 计算备注
                    cucode: null, // 创建人编码
                    cuname: null, // 创建人名称
                    cdate: null, // 创建时间
                    lucode: null, // 修改人编码
                    ldate: null, // 最后更新时间
                    delflag: null, // 可用标志。1：可用,0：删除标志
                },
                //table列表
                tableData: [],
                //操作标志
                optflag: 'save',
            }
        },

        created() {
            this.jiazaigongshibiao();
            this.query();
        },

        methods: {


            jiazaigongshibiao() {

                ss.FormulaNew.gaishugongshiselectList().then(rd => {

                    this.gongshiduizhaobiao = rd;

                    console.log(rd,'rd')

                })

            },


            //修改公式
            xiigaishuzhi(q) {

                console.log(q, 'aaa')

                this.kaishixiugai = true;

                this.xiugaifrom.type = q.type||"";

                this.xiugaifrom.name = q.name||"";

                this.xiugaifrom.proName = q.proName||"";

                this.xiugaifrom.modelName = q.modelName||"";

                this.xiugaifrom.formula = q.formula||"";

                this.xiugaifrom.oper = q.oper||"";

                this.xiugaifrom.ratetext = q.ratetext||"";

                this.xiugaifrom.id = q.id||"";

                var d = q.formula.split(/[\+\-\*/]/)

                var m = [];

                for(var c in d){

                    var p = d[c].replace(/\(+/, "")

                    var ss = p.replace(/\)+/, "")

                    if((/[a-zA-Z]\d+/).test(ss)){

                        for(var ddd in this.gongshiduizhaobiao){

                            if(this.gongshiduizhaobiao[ddd].formulanum==ss){

                                var cc = (" 编号: "+ss+" 名: "+(this.gongshiduizhaobiao[ddd].name||' ')+" 大项名: "+(this.gongshiduizhaobiao[ddd].proName||' ')+" 模块名: "+(this.gongshiduizhaobiao[ddd].modelName||' '));

                                m.push(cc);

                                this.xiugaifrom.duizhaobiao += (cc+'\n');

                            }

                        }

                    }

                }

                this.xiugaifrom.canshushuzu = [...new Set(m)];

                console.log(this.xiugaifrom.canshushuzu,'this.xiugaifrom.canshushuzu')



            },



            //确定要修改
            quedingxiugai() {

                this.$confirm('确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        var entity = {


                        }

                        for(var d in this.xiugaifrom){

                            if(this.xiugaifrom[d]!=null&&this.xiugaifrom[d]!=''&&d!='duizhaobiao'){

                                entity[d] = this.xiugaifrom[d];
                                console.log(entity[d],'aaaa?')

                            }

                        }

                        console.log(entity,'aawwww')

                        //更新值
                        ss.FormulaNew.gongshineixiaogaishuupdate(entity).then(rd => {

                            //如果成功
                            if (rd.f == true) {

                                //更新值
                                this.query();

                                //关窗
                                this.kaishixiugai = false;

                            }

                        })

                    })
                    .catch(_ => {

                    });


            },

            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },


            query() {

                ss.FormulaNew.gongshineixiaogaishuselectPage(this.q).then(rd => {

                    this.q.total = rd.total;
                    this.tableData = rd.records;

                })
            },


            handleFilter() {

                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },

            //导表
            outexcel() {

                ss.FormulaNew.gongshigaidownloadExcel();

            },


        }
    }
</script>